import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { DialogComponent } from '@comparit/core';

@Component({
  selector: 'ui-sort-info-modal',
  imports: [DialogComponent, MatIconModule],
  templateUrl: './sort-info-modal.component.html',
  styleUrl: './sort-info-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SortInfoModalComponent {}
